export const defaultLegendOptions = {
  icon: 'circle',
  type: 'scroll',
  selectedMode:true,
  orient: 'horizontal',
  itemHeight: 8,
  itemWidth: 8,
  left:'auto',
  padding:[10,10,0,0],
  itemGap: 18,
  pageIconColor: '#444444', //翻页下一页的三角按钮颜色
  pageIconInactiveColor: '#888888', //翻页（即翻页到头时）
  pageIconSize: 12, //翻页按钮大小
  pageButtonPosition: 'end',//start
  width: '100%',
  textStyle: { //图例文字的样式
    color: '#888888',
    fontSize: 12,
    lineHeight: 16,
  }
}

export const defaultPieSeries = {
  name: "",
  type: 'pie',
  minAngle: 5,
  avoidLabelOverlap: true,
  radius: '60%',
  labelLine: {
    //设置延长线的长度
    length: 20,
    length2: 20
  },
  label: {
    // alignTo: 'edge',
    minMargin: 5,
    edgeDistance: 10,
    lineHeight: 15,
    padding: [0, -6],
    rich: {
      a: {
        color: '#999',
        lineHeight: 15, //设置最后一行空数据高度，为了能让延长线与hr线对接起来
        align: 'center',
      },
      hr: {
        //设置hr是为了让中间线能够自适应长度
        borderColor: 'auto', //hr的颜色为auto时候会主动显示颜色的
        width: "100%",
        borderWidth: 0.5,
        height: 0.5,
        marginTop: -10,
      },
      per: {
        //用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
        padding: [4, 0],
      },
    },
  },
}

export const defaultGridOptions = {
  left: '3%',
  right: '4%',
  bottom: '3%',
  containLabel: true
}

export const defaultTooltip = {
  trigger: 'axis',
  axisPointer: {
    type: 'line'
  }
}

export const defaultYAxis = [
  {
    type: 'value'
  }
]
